<template lang="pug">
    include ../../media/pug/mixins.pug

    +b.menu-panel.document-page__menu-panel(v-show="!isMobile || (isMobile && isMenuPanelVisible)")
        +e.logo.ROUTER-LINK(
            v-if="!isMobile"
            title="Перейти на входную страницу"
            v-bind:to="routerLogoAction"
        )
            v-icon(name="logo-neb-round")
            +e.P.logo-title Национальная электронная библиотека
        template(v-if="$route.name === 'Document'")
            +e.UL.section._actions._left
                +e.LI.item(
                v-for="(actionButton, index) in visibleActionButtonsLeft"
                v-bind:key="`action-button-${index}`"
                v-bind:class="actionButton.border ? `menu-panel__item_border_${actionButton.border}` : false"
                )
                    +e.BUTTON.btn.btn(
                    v-if="!actionButton.select"
                    v-bind:class="actionButtonStyles(actionButton.styles)"
                    v-bind:title="actionButton.title"
                    v-on:click="actionButton.action"
                    )
                        +e.V-ICON.icon(v-bind:name="actionButton.icon")
        +e.UL.section._navigation(v-if="$route.name !== 'Enter' && $route.name !== 'DocumentError'")
            +e.LI.item
                +e.BUTTON.btn.btn(
                    v-bind:class="{'menu-panel__btn_is_disabled': +localPage <= 1 || !isErrorVision }"
                    type="button"
                    v-bind:title="$t('FIRST_PAGE')"
                    v-on:click="changePage(1)"
                )
                    +e.V-ICON.icon(name="first-pag-icon-bold")
            +e.LI.item
                +e.BUTTON.btn.btn(
                    v-bind:class="{'menu-panel__btn_is_disabled':  +localPage <= 1 || !isErrorVision }"
                    type="button"
                    v-bind:title="$t('PREVIOUS_PAGE')"
                    v-on:click="changePage(--localPage)"
                )
                    +e.V-ICON.icon(name="left")
            +e.LI.item
                +e.LABEL.field
                    +e.INPUT.input(
                        type="text"
                        v-model.number="localPage"
                        v-on:keyup.enter="changePage"
                        v-on:blur='changePage'
                    )
                    +e.text(
                        v-bind:class="{'menu-panel__text_is_disabled':  !isErrorVision}"
                    ) / {{ getGeneralInfo.maxPages }}
            +e.LI.item
                +e.BUTTON.btn.btn(
                    v-bind:class=
                    "{'menu-panel__btn_is_disabled': +localPage === getGeneralInfo.maxPages || !isErrorVision }"
                    type="button"
                    v-bind:title="$t('NEXT_PAGE')"
                    v-on:click="changePage(++localPage)"
                )
                    +e.V-ICON.icon(name="right")
            +e.LI.item
                +e.BUTTON.btn.btn(
                    v-bind:class=
                    "{'menu-panel__btn_is_disabled': +localPage === getGeneralInfo.maxPages || !isErrorVision }"
                    type="button"
                    v-bind:title="$t('LAST_PAGE')"
                    v-on:click="changePage(getGeneralInfo.maxPages)"
                )
                   +e.V-ICON.icon(name="last-pag-icon-bold")
        +e.UL.section._actions._right(v-if="!isMobile && $route.name !== 'Enter' && $route.name !== 'DocumentError'")
            +e.LI.item(
                v-for="(actionButton, index) in visibleActionButtonsRight"
                v-bind:key="`action-button-${index}`"
                v-bind:class=
                "actionButton.border ? `menu-panel__item_border_${actionButton.border}` : false"
            )
                +e.BUTTON.btn.btn(
                    v-if="!actionButton.select"
                    v-bind:class="actionButtonStyles(actionButton.styles)"
                    v-bind:title="actionButton.title"
                    v-on:click="actionButton.action"
                )
                    +e.V-ICON.icon(v-bind:name="actionButton.icon")
                +e.V-SELECT.select.select(
                    v-else
                    v-bind:class="{'select_is_disabled': !isErrorVision}"
                    v-on:open="openSelect"
                    v-on:close="closeSelect"
                    v-bind:options="zoomSteps"
                    v-bind:clearable="false"
                    v-bind:searchable="false"
                    v-bind:allow-empty="false"
                    v-bind:show-labels="false"
                    v-bind:maxHeight="500"
                    v-model="value"
                    v-on:input="changeZoomSelect"
                )
                    template(slot="singleLabel", slot-scope="props") {{ Math.round(zoom * 100) }}%
                    .select__option(
                        slot="option", slot-scope="props"
                        v-bind:class="{'select__option_border_top': props.option.topBorder}"
                    ) {{ props.option.title }}
        +e.section._document-title(v-if="isMobile")
            +e.SPAN.description_title
                | {{documentTitle}}
                | #[+e.SPAN.link.link._dashed(v-on:click="openModal('RslCardItem')") {{$t('DESCRIPTION')}}]

</template>

<script>
import { mapGetters } from 'vuex';
import zoom from '@/helpers/mixins/zoom';
import documentView from '@/helpers/mixins/document-view';
import onePageScroll from '@/helpers/mixins/one-page-scroll';

export default {
    mixins: [zoom, documentView, onePageScroll],
    data() {
        return {
            localPage: 0,
            fullHeight: false,
            fullWidth: false,
            startWidth: 1240,
            zoom: 1,
            value: 100,
            rotateImage: 90,
            isNegative: false
        };
    },
    computed: {
        ...mapGetters([
            'getMainImageParams',
            'getZoom',
            'getIsOnePage',
            'getGeneralInfo',
            'getDocInfo',
            'getIsSearchable',
            'getTextPageCurrentFlag',
            'isMobile',
            'isTablet',
            'isDesktop',
            'isAddMarkMode',
            'isMenuPanelVisible',
            'isSidebarVisible',
            'getCartPages',
            'isMainImgLandscape'
        ]),
        isErrorVision() {
            return this.$route.params.id;
        },
        routerLogoAction() {
            if (this.isErrorVision) {
                return {
                    name: 'Enter',
                    params: {
                        id: this.$route.params.id
                    },
                    query: {
                        ...this.$route.query
                    }
                };
            }
            return { name: 'DocumentError' };
        },
        actionButtonsLeft() {
            return [
                {
                    isHidden: !this.isMobile,
                    title: this.$t('ROTATE_RIGHT'),
                    styles: {
                        active: false,
                        disabled: this.getTextPageCurrentFlag
                    },
                    action: () => this.rotateImageFunc('right'),
                    icon: 'rotete-right'
                },
                {
                    title: this.$t('NEGATIVE'),
                    isHidden: !this.isMobile,
                    styles: {
                        active: this.isNegative,
                        disabled: this.getTextPageCurrentFlag
                    },
                    action: () => this.changeNegative(),
                    icon: 'negative'
                },
                {
                    isHidden: !this.isMobile,
                    title: this.$t('ROTATE_LEFT'),
                    styles: {
                        active: false,
                        disabled: this.getTextPageCurrentFlag || this.getIsOnePage || !this.isErrorVision
                    },
                    action: () => this.rotateImageFunc('left'),
                    icon: 'rotate-left'
                }
            ];
        },
        actionButtonsRight() {
            return [
                {
                    isHidden: !this.isDesktop,
                    title: this.$t('FULL_HEIGHT'),
                    styles: {
                        active: this.fullHeight,
                        disabled: this.getTextPageCurrentFlag || !this.isErrorVision
                    },
                    action: () => this.$documentView.setFullHeight(),
                    icon: 'full-height-icon'
                },
                {
                    isHidden: !this.isDesktop,
                    title: this.$t('FULL_WIDTH'),
                    styles: {
                        active: this.fullWidth,
                        disabled: this.getTextPageCurrentFlag || !this.isErrorVision
                    },
                    action: () => this.$documentView.setFullWidth(),
                    icon: 'full-width-icon'
                },
                {
                    title: this.$t('ROTATE_RIGHT'),
                    styles: {
                        active: false,
                        disabled: this.getTextPageCurrentFlag || this.getIsOnePage || !this.isErrorVision
                    },
                    action: () => this.rotateImageFunc('right'),
                    icon: 'rotete-right'
                },
                {
                    isHidden: !this.isDesktop,
                    title: this.$t('ROTATE_LEFT'),
                    styles: {
                        active: false,
                        disabled: this.getTextPageCurrentFlag || this.getIsOnePage || !this.isErrorVision
                    },
                    action: () => this.rotateImageFunc('left'),
                    icon: 'rotate-left'
                },
                {
                    title: this.$t('NEGATIVE'),
                    styles: {
                        active: this.isNegative,
                        disabled: this.getTextPageCurrentFlag || !this.isErrorVision
                    },
                    action: () => this.changeNegative(),
                    icon: 'negative'
                },
                {
                    isHidden: this.isMobile,
                    select: true
                }
            ];
        },
        visibleActionButtonsLeft() {
            return this.actionButtonsLeft.filter(button => !button.isHidden);
        },
        visibleActionButtonsRight() {
            return this.actionButtonsRight.filter(button => !button.isHidden);
        },
        documentTitle() {
            let title = `${this.getDocInfo.authorInfo} ${this.getDocInfo.cardTitle}`;
            if (title.length >= 100) {
                title = `${title.substring(0, 100)}...`;
            }
            return title;
        },
        zoomSteps() {
            const arr = [
                {
                    title: '25%',
                    value: 0.25
                },
                {
                    title: '50%',
                    value: 0.50
                },
                {
                    title: '75%',
                    value: 0.75
                },
                {
                    title: '100%',
                    value: 1.00
                },
                {
                    title: '150%',
                    value: 1.50
                },
                {
                    title: '200%',
                    value: 2.00
                },
                {
                    title: '250%',
                    value: 2.50
                },
                {
                    title: '300%',
                    value: 3.00
                },
                {
                    title: this.$t('BY_WIDTH'),
                    value: 'full width',
                    topBorder: true,
                    isHidden: !this.isTablet
                },
                {
                    title: this.$t('BY_HEIGHT'),
                    value: 'full heigth',
                    isHidden: !this.isTablet
                }
            ];
            return arr.filter(item => !item.isHidden);
        },
        isInCart() {
            return this.getCartPages.indexOf(+this.$route.query.page) !== -1;
        }
    },
    watch: {
        getZoom(value) {
            this.zoom = +(+value).toFixed(2);
            this.isNotStandart = !!(this.value % Math.round(this.zoomStep * 100));
            this.checkZoom();
        },
        $route: {
            immediate: true,
            handler(to, from) {
                if (from && from.query.rotate !== to.query.rotate) {
                    this.checkZoom();
                }
                this.isNegative = this.$route.query.negative === '1';
                this.localPage = to.query.page;
            }
        },
        localPage(val) {
            if (val < 0) {
                this.localPage = 1;
            } else if (val > this.getGeneralInfo.maxPages) {
                this.localPage = this.getGeneralInfo.maxPages;
            }
        }
    },
    mounted() {
        document.addEventListener('keydown', this.keyboardFunc);
    },
    methods: {
        changePage(page) {
            let currentPage;
            if (page.target) {
                currentPage = page.target.value;
            } else {
                currentPage = page;
            }

            if (currentPage < 1) {
                this.localPage = 1;
                currentPage = 1;
            }
            if (currentPage > 0 && currentPage <= this.getGeneralInfo.maxPages) {
                this.$router.push({
                    query: {
                        page: currentPage,
                        rotate: this.$route.query.rotate,
                        negative: this.$route.query.negative
                    }
                });
            }
            if (this.getIsOnePage) this.$onePageScroll(page);
        },
        checkZoom() {
            this.fullHeight = null;
            this.fullWidth = null;
            if (this.isMainImgLandscape) {
                this.fullHeight = (this.$documentView.calcHeight() / this.getMainImageParams.width).toFixed(2)
                                    === this.getZoom;
                this.fullWidth = (this.$documentView.calcWidth() / this.getMainImageParams.height).toFixed(2)
                                    === this.getZoom;
            } else {
                this.fullHeight = (this.$documentView.calcHeight() / this.getMainImageParams.height).toFixed(2)
                                    === this.getZoom;
                this.fullWidth = (this.$documentView.calcWidth() / this.getMainImageParams.width).toFixed(2)
                                    === this.getZoom;
            }
        },
        openSelect() {
            document.querySelector('.document-view__scroll-container').style.pointerEvents = 'none';
        },
        closeSelect() {
            document.querySelector('.document-view__scroll-container').style.pointerEvents = 'auto';
        },
        addPageToCart() {
            this.$store.commit('ADD_TO_CART', +this.$route.query.page);
            this.$store.dispatch('showNotification', {
                text: 'Добавлено в',
                actionText: 'корзину',
                action: () => (this.$store.commit('SET_CURRENT_SIDEBAR_TAB', 'ShopCart')),
                status: 'correct',
                isVisible: true
            });
        },
        actionButtonStyles(item) {
            return {
                'menu-panel__btn_is_active': item.active,
                'menu-panel__btn_is_disabled': item.disabled
            };
        },
        showTextPage() {
            this.$store.commit('SET_TEXT_PAGE_FLAG');
        },
        checkQueryParam(value) {
            return !value ? 0 : value;
        },
        changeNegative() {
            const negative = this.checkQueryParam(this.$route.query.negative);
            const rotate = this.checkQueryParam(this.$route.query.rotate);
            if (!this.getTextPageCurrentFlag) {
                const newNegative = +!+negative;
                this.isNegative = !this.isNegative;
                this.$router.push({
                    query: {
                        page: this.$route.query.page,
                        rotate,
                        negative: `${newNegative}`
                    }
                });
            }
        },
        openModal(val) {
            if (val === 'ModalDownload') {
                if (this.getGeneralInfo.isLogin) {
                    this.$store.dispatch('showModal', val);
                } else {
                    this.$store.dispatch('showModal', 'ModalError');
                }
            } else {
                this.$store.dispatch('showModal', val);
            }
        },
        rotateMath(val) {
            const rotate = this.checkQueryParam(+this.$route.query.rotate);
            if (!this.getTextPageCurrentFlag) {
                this.activeBtn = '';
                switch (true) {
                default: return false;
                case val === 'right' && rotate === 270:
                case val === 'left' && rotate === -270:
                    return 0;
                case val === 'right' && rotate !== 270:
                    return rotate + this.rotateImage;
                case val === 'left' && rotate !== -270:
                    return rotate - this.rotateImage;
                }
            }
            return false;
        },
        rotateImageFunc(val) {
            if (!this.getTextPageCurrentFlag) {
                this.activeBtn = '';
                this.$router.push({
                    query: {
                        page: this.$route.query.page,
                        rotate: +this.rotateMath(val),
                        negative: this.$route.query.negative
                    }
                });
            }
        },
        changeOnePage() {
            if (!this.getTextPageCurrentFlag) {
                if (!this.getIsOnePage) {
                    this.$router.push({
                        query: {
                            page: this.$route.query.page,
                            rotate: '0',
                            negative: this.$route.query.negative
                        }
                    });
                }
                this.$store.commit('SET_ONE_PAGE_STATE', !this.getIsOnePage);
            }
        },
        changeZoomSelect() {
            if (typeof this.value.value !== 'number') {
                if (this.value.value === 'full width') {
                    this.$documentView.setFullWidth();
                }
                if (this.value.value === 'full heigth') {
                    this.$documentView.setFullHeight();
                }
            } else {
                this.$store.commit('SET_NEW_ZOOM', this.value.value);
            }
        },
        changeZoom() {
            this.$store.commit('SET_NEW_ZOOM', this.zoom);
        },
        keyboardFunc(e) {
            if (this.$route.params.id) {
                const contentImg = document.querySelector('.document-view__scroll-container');
                if (e.ctrlKey) {
                    if (e.key === 'ArrowRight') {
                        this.changePage(+this.localPage + 1);
                    }
                    if (e.key === 'ArrowLeft') {
                        this.changePage(+this.localPage - 1);
                    }
                }
                if (e.shiftKey) {
                    if (e.key === 'ArrowUp') {
                        this.$zoom.in();
                    }
                    if (e.key === 'ArrowDown') {
                        this.$zoom.out();
                    }
                    if (e.code === 'KeyF') {
                        this.changePage(1);
                    }
                    if (e.code === 'KeyL') {
                        this.changePage(this.getGeneralInfo.maxPages);
                    }
                    if (e.code === 'KeyP') {
                        this.$store.commit('SET_SIDEBAR_IS_VISIBLE', !this.isSidebarVisible);
                    }
                    if (e.code === 'KeyW') {
                        this.$documentView.setFullWidth();
                    }
                    if (e.code === 'KeyH') {
                        this.$documentView.setFullHeight();
                    }
                }
                if (e.code === 'PageUp') {
                    contentImg.scrollTop -= 20;
                }
                if (e.code === 'PageDown') {
                    contentImg.scrollTop += 20;
                }
                if (e.code === 'Home') {
                    contentImg.scrollLeft -= 20;
                }
                if (e.code === 'End') {
                    contentImg.scrollLeft += 20;
                }
            }
        }
    }
};
</script>

<style lang="sass" src="@/media/sass/components/partials/menu-panel.sass"></style>
